import React from 'react';
import { isChinaFrontend } from '@utils/isChinaFrontend';
import GoogleButton from './GoogleButtonLogin';
import WeChatButton from './WeChatButtonLogin';

type PrimarySocialLoginButtonProps = {
  code?: string;
  productId?: string;
};

/**
 * Shows WeChat login on China-served frontends, Google elsewhere.
 */
const PrimarySocialLoginButton = ({ code, productId }: PrimarySocialLoginButtonProps) => {
  if (isChinaFrontend()) {
    return <WeChatButton code={code} productId={productId} />;
  }
  return <GoogleButton code={code} productId={productId} />;
};

export default PrimarySocialLoginButton;
